import { NgModule } from '@angular/core';
import { MenubarModule } from 'primeng/menubar';
import { SplitButtonModule } from 'primeng/splitbutton';
import { StepsModule } from 'primeng/steps';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingComponent } from './loading/loading.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TooltipModule } from 'primeng/tooltip';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ToastModule } from 'primeng/toast';
import { CustomContextMenuDirective } from 'src/app/shared/directives/custom-context-menu.directive';
import { CustomProgressbarDirective } from 'src/app/shared/directives/custom-progressbar.directive';
import { CommonModule } from '@angular/common';
import { ProgressBarModule } from 'primeng/progressbar';
import { TabViewModule } from 'primeng/tabview';
import { ListboxModule } from 'primeng/listbox';
import { DopTableModule } from 'projects/dop-table/src/public_api';
import { AppFooterComponent } from './app-footer/app-footer.component';
import { AppPageHeaderComponent } from './app-page-header/app-page-header.component';
import { HighlightSearch } from './pipes/highlight-search.pipe';
import { AccountDisplay } from './pipes/account-display.pipe';
import { QuotationDisplay } from './pipes/quotation-display.pipe';
import { CustomVirtualScrollerDirective } from './directives/custom-virtual-scroller.directive';
import { ContractDisplay } from './pipes/contract-display.pipe';
import { DopCoreModule } from 'projects/dop-core/src/public-api';
import { AnalysisCodeDisplay } from './pipes/analysis-code-display.pipe';
import { StringFormatterPipe } from './pipes/string-formatter.pipe';
import { ErrorMessageDirective } from './directives/error-message.directive';
import { AnalysesDetailComponent } from './analyses-detail/analyses-detail.component';
import { SpecificationDetailComponent } from './specification-detail/specification-detail.component';
import { DopOrderingModule } from 'projects/dop-ordering/src/public-api';
import { AdditionalFieldsComponent } from './additional-fields/additinal-fields.component';
import { InfiniteScrollComponent } from './components/infinite-scroll/infinite-scroll.component';
import { AppConfirmDialogComponent } from './dialogs/app-dialog/app-confirm-dialog.component';
import { InfoDialogComponent } from './dialogs/info-dialog/info-dialog.component';
import { OrderDetailPreviewComponent } from './order-detail-preview/order-detail-preview.component';
import { NgxBarcodeModule } from 'ngx-barcode';
import { SampleGridPreviewComponent } from './sample-grid-preview/sample-grid-preview.component';
import { InputNumberDirective } from './directives/input-number.directive';
import { PrintSampleBarcodeComponent } from './print-sample-barcode/print-sample-barcode.component';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { FavOrderDialogComponent } from 'src/app/shared/fav-order-dialog/fav-order-dialog.component';
import { EditAdditionalFieldsComponent } from './edit-additional-fields/edit-additional-fields.component';
import { StringFormatDirective } from './directives/string-format.directive';
import { PercentageLoadingComponent } from './percentage-loading/percentage-loading.component';
import { PercentageLoadingService } from './percentage-loading/percentage-loading.service';
import { OrderBy } from './pipes/orderby.pipe';
import { EditOrderWarningDialogComponent } from './dialogs/edit-order-warning-dialog/edit-order-warning-dialog.component';
import { LogoutComponent } from './logout/logout.component';
import { DragDropDirective } from './directives/drag-drop.directive';
import { DeleteAttachmentDialogComponent } from './dialogs/delete-attachment/delete-attachment-dialog.component';
import { LegacyMatrixService } from './services/legacy-matrix.service';
import { TableClearInputDirective } from './directives/table-clear-input.directive';
import { MonographToolTipComponent } from './monograph-tool-tip/monograph-tool-tip.component';
import { ClearInputDirective } from './directives/clear-input-directive';
import { DialogService } from 'primeng/dynamicdialog';
import { SampleQuantityComponent } from './sample-quantity/sample-quantity.component';
import { SharedMessageService } from './services/shared-message.service';
import { TruncateTextPipe } from './pipes/truncate-text.pipe';
import { ScheduleOrderDialogComponent } from './schedule-order-dialog/schedule-order-dialog.component';
import { LabsiteCheckService } from './labsite-check/labsite-check.service';
// import { GlobalHeaderComponent } from './global-header/global-header.component';

// left nav changes container
// New conponent for nav left
// end
@NgModule({
  declarations: [
    AppFooterComponent,
    AppPageHeaderComponent,
    LoadingComponent,
    CustomContextMenuDirective,
    CustomProgressbarDirective,
    CustomVirtualScrollerDirective,
    HighlightSearch,
    AccountDisplay,
    QuotationDisplay,
    ContractDisplay,
    AnalysisCodeDisplay,
    ErrorMessageDirective,
    StringFormatterPipe,
    AnalysesDetailComponent,
    SpecificationDetailComponent,
    AdditionalFieldsComponent,
    InfiniteScrollComponent,
    AppConfirmDialogComponent,
    InfoDialogComponent,
    OrderDetailPreviewComponent,
    SampleGridPreviewComponent,
    InputNumberDirective,
    PrintSampleBarcodeComponent,
    FavOrderDialogComponent,
    EditAdditionalFieldsComponent,
    StringFormatDirective,
    PercentageLoadingComponent,
    OrderBy,
    EditOrderWarningDialogComponent,
    LogoutComponent,
    DragDropDirective,
    DeleteAttachmentDialogComponent,
    TableClearInputDirective,
    MonographToolTipComponent,
    ClearInputDirective,
    SampleQuantityComponent,
    TruncateTextPipe,
    ScheduleOrderDialogComponent,
    // GlobalHeaderComponent
  ],
  imports: [
    ReactiveFormsModule,
    RxReactiveFormsModule,
    StepsModule,
    BreadcrumbModule,
    MenubarModule,
    SplitButtonModule,
    ProgressSpinnerModule,
    ProgressBarModule,
    CommonModule,
    TabViewModule,
    ListboxModule,
    TooltipModule,
    OverlayPanelModule,
    DopOrderingModule,
    DialogModule,
    DopTableModule,
    DopCoreModule,
    PanelModule,
    TableModule,
    NgxBarcodeModule,
    DropdownModule,
    RadioButtonModule,
    FormsModule,
    CalendarModule,
    CheckboxModule,
    ToastModule
  ],
  exports: [
    AppFooterComponent,
    AppPageHeaderComponent,
    FormsModule,
    StepsModule,
    BreadcrumbModule,
    MenubarModule,
    SplitButtonModule,
    ProgressBarModule,
    LoadingComponent,
    AnalysesDetailComponent,
    SpecificationDetailComponent,
    TabViewModule,
    CustomContextMenuDirective,
    CustomProgressbarDirective,
    ListboxModule,
    TooltipModule,
    DialogModule,
    DopTableModule,
    HighlightSearch,
    CustomVirtualScrollerDirective,
    AccountDisplay,
    QuotationDisplay,
    ContractDisplay,
    DopCoreModule,
    AnalysisCodeDisplay,
    StringFormatterPipe,
    ErrorMessageDirective,
    AdditionalFieldsComponent,
    InfiniteScrollComponent,
    AppConfirmDialogComponent,
    InfoDialogComponent,
    OrderDetailPreviewComponent,
    SampleGridPreviewComponent,
    InputNumberDirective,
    PrintSampleBarcodeComponent,
    EditAdditionalFieldsComponent,
    StringFormatDirective,
    PercentageLoadingComponent,
    OrderBy,
    EditOrderWarningDialogComponent,
    ToastModule,
    DragDropDirective,
    DeleteAttachmentDialogComponent,
    TableClearInputDirective,
    ClearInputDirective,
    SampleQuantityComponent,
    TruncateTextPipe,
    // GlobalHeaderComponent
  ],
  providers: [
    StringFormatterPipe,
    DialogService,
    PercentageLoadingService,
    LegacyMatrixService,
    SharedMessageService,
    LabsiteCheckService
  ]
})
export class SharedModule { }
